import { formatDate } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isDate, isToday, isTomorrow, isValid, isYesterday } from 'date-fns';

@Injectable({ providedIn: 'root' })
export class DateFormattingService {
  private translateService = inject(TranslateService);

  wordedDate(dateInput: string | Date | null, format = 'EEEE d MMMM yyyy'): string | null {
    if (!dateInput) {
      return null;
    }

    if (isYesterday(dateInput)) {
      return this.translateService.instant('qz-yesterday-zm');
    } else if (isToday(dateInput)) {
      return this.translateService.instant('qz-today-zm');
    } else if (isTomorrow(dateInput)) {
      return this.translateService.instant('qz-tomorrow-zm');
    } else {
      return this.formattedDate(dateInput, format);
    }
  }

  formattedDate(dateInput: string | Date | null, format = 'd MMMM yyyy'): string | null {
    if (!dateInput || (isDate(dateInput) && !isValid(dateInput))) {
      return null;
    }

    const locale = this.translateService.currentLang() ?? this.translateService.fallbackLang();
    // @ts-expect-error TS2345 argument not assignable
    return formatDate(dateInput, format, locale);
  }
}
